import {
  all, call, put, select, take,
} from 'redux-saga/effects';
import {
  compose, find, get, reject,
} from 'lodash/fp';

import { ERROR_DISPLAY_TYPE } from '../common/constants';
import * as errorActions from '../errors/actions';
import * as notificationServices from '../notification/services';
import * as actions from './actions';
import * as services from './services';

export function* fetchMyAdminApplications() {
  while (true) {
    try {
      yield take(actions.FETCH_MY_ADMIN_APPLICATIONS_REQUEST);
    } catch (error) {
      yield put(actions.fetchMyAdminApplicationsFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}

export function* createAdminApplication() {
  while (true) {
    try {
      const action = yield take(actions.CREATE_ADMIN_APPLICATION_REQUEST);

      const { sid, values } = action.payload;

      const response = yield call(services.fetchAdminApplications, { sid });

      const adminApplications = response.data;
      const adminApplication = find(application => (
        values.name === get('name', application)
        && values.jobPosition === get('job_position', application)
        && values.email === get('email', application)
      ), adminApplications);

      if (!adminApplication) {
        yield all([
          call(services.createAdminAppication, {
            sid,
            ...values,
          }),
          call(notificationServices.sendAdminRequestNotification, values),
        ]);
      }

      yield put(actions.createAdminApplicationSuccess({ adminApplication: adminApplication || true }));
    } catch (error) {
      yield put(actions.createAdminApplicationFailure({ error }));

      yield put(errorActions.errorOccured({ error }));
    }
  }
}

export function* fetchSchoolAdminRelationships() {
  while (true) {
    let retry;
    try {
      const action = yield take(actions.FETCH_SCHOOL_ADMIN_RELATIONSHIPS_REQUEST);

      const {
        onRetry, page, perPage, sid,
      } = action.payload;

      retry = onRetry;

      const response = yield call(services.fetchSchoolAdminRelationships, { page, perPage, sid });

      const schoolAdminRelationships = {
        rows: get('data', response),
        total: get('headers.total', response),
        perPage: get('headers.per-page', response),
      };

      yield put(actions.fetchSchoolAdminRelationshipsSuccess({ schoolAdminRelationships }));
    } catch (error) {
      yield put(actions.fetchSchoolAdminRelationshipsFailure({ error }));

      yield put(errorActions.errorOccured({
        message: '목록을 불러오는 데 실패하였습니다. 다시 시도하시겠습니까?',
        type: ERROR_DISPLAY_TYPE.DIALOG,
        error,
        onRetry: retry,
      }));
    }
  }
}

export function* deleteAdminRelationship() {
  while (true) {
    try {
      const action = yield take(actions.DELETE_ADMIN_RELATIONSHIP_REQUEST);

      const {
        page, perPage, schoolId, target,
      } = action.payload;

      yield call(services.deleteAdminRelationship, { id: target.id });

      const userInfo = yield select(state => state.user.info);

      let updatedSchoolAdminRelationships;

      if (userInfo.user_id !== target.user.uid) {
        let response;

        try {
          response = yield call(services.fetchSchoolAdminRelationships, { page, perPage, sid: schoolId });
        } catch (error) {
          yield put(actions.fetchSchoolAdminRelationshipsFailure({ error }));
        }

        const schoolAdminRelationships = yield select(state => state.admin.schoolAdminRelationships);

        updatedSchoolAdminRelationships = response
          ? {
            rows: get('data', response),
            total: get('headers.total', response),
            perPage: get('headers.per-page', response),
          }
          : {
            rows: compose(
              reject(adminRelationship => adminRelationship.user.uid === userInfo.user_id),
              get('rows'),
            )(schoolAdminRelationships.data),
            total: get('total', schoolAdminRelationships.data),
            perPage: get('perPage', schoolAdminRelationships.data),
          };
      }

      yield put(actions.deleteAdminRelationshipSuccess({
        adminDeleted: target.user.uid,
        schoolAdminRelationships: updatedSchoolAdminRelationships,
      }));
    } catch (error) {
      yield put(actions.deleteAdminRelationshipFailure({ error }));

      yield put(errorActions.errorOccured({
        message: '삭제에 실패하였습니다.',
        type: ERROR_DISPLAY_TYPE.SNACKBAR,
        error,
      }));
    }
  }
}
